import routes from 'global/Constants/routes';
import { lazy } from 'react';

const ProductTypePage = lazy(() => import('../../pages/dashboard/productType/ProductTypePage'));
const BranchCustomerProductTypePage = lazy(() => import('../../pages/dashboard/branchCustomerProductType/branchCustomerProductPage'));
export const productTypeRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.productType.path,
    component: ProductTypePage,
    isPrivate: routes.productType.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.branchCustomerProductType.path,
    component: BranchCustomerProductTypePage,
    isPrivate: routes.branchCustomerProductType.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
